import { useEffect } from "react";
import styles from "./AdminCustomerDetailsPage.module.scss";
import { useLazyGetCustomerOnboardingStatusQuery } from "../../../service/customer-service";
import { toast } from "react-toastify";
import { formatDate, formatTime } from "../../../utils";
import { CircleCheckmark } from "../../../assets/icons";

interface OnboardingStatusProps {
	customerId: string;
}
const OnboardingStatus: React.FC<OnboardingStatusProps> = ({ customerId }) => {
	const [getOnboardingStatus, { data, isLoading }] = useLazyGetCustomerOnboardingStatusQuery();
	useEffect(() => {
		getOnboardingStatus(customerId).unwrap()
		.then()
		.catch(err=> toast.error(err?.data?.title as string));
	}, []);

	return (
		<div className={styles.onboardingStatusContainer}>
			{data?.map((item, index) => (
				<div key={index} className={styles.row}>
					<div className={`${styles.column} ${styles.status}`}><CircleCheckmark /> {item?.type}</div>
					<div className={styles.column}>
						<span>{formatTime(item?.date)}</span> | {formatDate(item?.date)}
					</div>
				</div>
			))}
		</div>
	);
};

export default OnboardingStatus;
